var shopInfoKey = function (platformStoreId) { return "reconvert/".concat(btoa(platformStoreId), "/info"); };
var authKey = function (platformStoreId) { return "reconvert/".concat(platformStoreId); };
var authExpiryKey = function (platformStoreId) { return "".concat(authKey(platformStoreId), ":e"); };
var storeSessionShopInfo = function (platformStoreId, shopInfo) {
    localStorage.setItem(shopInfoKey(platformStoreId), JSON.stringify(shopInfo));
};
var getSessionShopInfo = function (platformStoreId) {
    return JSON.parse(localStorage.getItem(shopInfoKey(platformStoreId)) || '{}');
};
var requestHandler = function (config) {
    var _a, _b;
    if (!config.headers['X-Platform-Store-Id']) {
        config.headers['X-Platform-Store-Id'] = ((_a = window.getPlatformStoreId) === null || _a === void 0 ? void 0 : _a.call(window)) ? btoa((_b = window.getPlatformStoreId) === null || _b === void 0 ? void 0 : _b.call(window)) : undefined;
    }
    var platformStoreId = config.headers['X-Platform-Store-Id'];
    if (platformStoreId && config.headers['X-Reconvert-Auth-Version'] == 1) {
        var session = getSession(platformStoreId);
        if (session) {
            config.headers['X-Reconvert-Authorization'] = "".concat(session);
        }
    }
    return config;
};
var responseHandler = function (res, config) {
    var platformStoreId = config.headers['X-Platform-Store-Id'];
    if (platformStoreId &&
        config &&
        config.headers['X-Reconvert-Auth-Version'] == 1) {
        var platformStoreId_1 = config.headers['X-Platform-Store-Id'];
        var expiry = res.headers['x-reconvert-session-expiry'];
        var session = res.headers['x-reconvert-session'];
        if (platformStoreId_1 && session && expiry) {
            localStorage.setItem(authKey(platformStoreId_1), session);
            localStorage.setItem(authExpiryKey(platformStoreId_1), expiry);
        }
    }
    return res;
};
var addInterceptors = function (axios) {
    // Add a request interceptor
    axios.interceptors.request.use(function (config) {
        config = requestHandler(config);
        return config;
    }, function (error) {
        return Promise.reject(error);
    });
    // Add a response interceptor
    axios.interceptors.response.use(function (res) {
        return responseHandler(res, res.config);
    }, function (error) {
        var _a, _b, _c, _d, _e;
        if (((_a = error === null || error === void 0 ? void 0 : error.config) === null || _a === void 0 ? void 0 : _a.headers) && ((_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.headers)
            && ((_c = error.config) === null || _c === void 0 ? void 0 : _c.headers["X-Platform-Store-Id"])
            && ((_d = error.response) === null || _d === void 0 ? void 0 : _d.headers["x-reconvert-session-invalid"]) == 1) {
            clearSession((_e = error.config) === null || _e === void 0 ? void 0 : _e.headers["X-Platform-Store-Id"]);
        }
        return Promise.reject(error);
    });
};
var getSession = function (platformStoreId) {
    var session = localStorage.getItem(authKey(platformStoreId));
    var expiry = localStorage.getItem(authExpiryKey(platformStoreId));
    if (session) {
        if (expiry && +expiry < new Date().getTime()) {
            clearSession(platformStoreId);
        }
        else {
            return session;
        }
    }
};
var clearSession = function (platformStoreId) {
    localStorage.removeItem(authKey(platformStoreId));
    localStorage.removeItem(authExpiryKey(platformStoreId));
};

export { addInterceptors, getSession, getSessionShopInfo, requestHandler, responseHandler, storeSessionShopInfo };
//# sourceMappingURL=axios.interceptor.js.map
